import PromptTag from "../PromptTag/PromptTag";

export default function PromptTagsContainer({ categories, selectedCategories, handlePromptTag }) {
    return(
        <div className="filter-bar-container">
            <div className="prompt-bar round-div">
                <p>Use case:</p>
                {
                    categories?.length > 0 && categories.map( ( category, idx )  => {

                        const active = selectedCategories?.includes( category ) ? true : false 
                        return  <PromptTag category={ category } key={ idx } active={ active } handlePromptTag={ handlePromptTag }/>
                    })

                }
            </div>
        </div>
    )
}